import { useMemo } from 'react';
import { useGetMultiDataSources } from '../queries';
import { IntegrationType, ListDataSourcesResponse } from '../types';

type UseIsPmsSyncEligibleProps =
  | { locationId: string; locationIds?: never }
  | { locationId?: never; locationIds: string[] };

export const useIsPmsSyncEligible = ({ locationId, locationIds }: UseIsPmsSyncEligibleProps) => {
  const resolvedLocationIds = useMemo(
    () => (locationIds !== undefined ? locationIds : locationId !== undefined ? [locationId] : []),
    [locationIds, locationId]
  );

  const results = useGetMultiDataSources<boolean>(
    { locationIds: resolvedLocationIds },
    { select: (data) => checkPmsSyncEligibility(data) }
  );

  return {
    isEligible: results.some((result) => Boolean(result.data)),
    isLoading: results.some((result) => result.isLoading),
  };
};

// Add more integration types as needed
const PMS_SYNC_ELIGIBLE_INTEGRATION_TYPES = [IntegrationType.ON_PREM, IntegrationType.CLOUD];

const checkPmsSyncEligibility = (dataSourcesResponse: ListDataSourcesResponse) => {
  return Boolean(
    dataSourcesResponse.dataSources?.some((dataSource) => {
      return (
        !!dataSource.integration?.type && PMS_SYNC_ELIGIBLE_INTEGRATION_TYPES.includes(dataSource.integration?.type)
      );
    })
  );
};
